import React, { useState, useEffect } from "react";
import "./Home.css";

const Home = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    "/img/remodelacion_casas.jpg",
    "/img/architecture-background.jpg",
    "/img/construction.jpg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="home-container" id="home">

      {/* Hero Section */}
      <section
        className="hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${images[currentImage]})`,
        }}
      >
        <div className="hero-overlay">
          <div className="hero-content">

            <h1 className="fade-in">CONSTRUIMOS FUTURO</h1>
            <p className="fade-in delay-1">
              En MS Group Constructora transformamos ideas en realidad 
              con calidad, confianza e innovación.
            </p>
            <div className="hero-buttons fade-in delay-2">
              <a href="#contact" className="btn-primary">
                Solicitar Cotización
              </a>
              <a href="#services" className="btn-secondary">
                Ver Servicios
              </a>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;